export const makeApiUrl = (path: string): string =>
  `https://us-central1-prod-self-service.cloudfunctions.net/api/v1${path}`;